/*
 * Prazo de entrega por UF — provedor de dados, sem interface.
 *
 * Quem desenha é quem consome (hoje: o bloco "entrega" do
 * sections/custom-pdp-select-one.liquid). Aqui só mora a parte que o tema não
 * tinha: descobrir o estado do visitante e converter a tabela de prazos em
 * data, contando dia útil e feriado nacional.
 *
 * O tema NÃO tem o IP do visitante: a Shopify não expõe isso no Liquid (não
 * existe request.ip). Então a UF é descoberta no navegador, uma vez por
 * visitante, e guardada no localStorage por 7 dias.
 *
 * Ordem das fontes de UF:
 *   1. UF fixada na mão (PHPrazo.definirUF) — vence tudo e não expira;
 *   2. cache do localStorage;
 *   3. endpoint próprio, se quem chamar passar um (ex.: PH CORE);
 *   4. API pública de geo-IP (a segunda só é chamada se a primeira falhar).
 *
 * Em celular o IP cai no gateway da operadora (CGNAT) e a UF erra com
 * frequência. Por isso nada aqui vira promessa de entrega sozinho: quando a UF
 * não aparece, obter() devolve null e quem chamou deve manter o que o Liquid
 * já tinha renderizado.
 */
(function () {
  'use strict';

  if (window.PHPrazo) return;

  /* ---------- tabela do negócio ----------
     [dias úteis, região, CEP da capital usado na cotação] */
  var TABELA = {
    SP: [2, 'Sudeste', '01310-000'],
    DF: [3, 'Centro-Oeste', '70355-000'],
    GO: [3, 'Centro-Oeste', '74053-010'],
    MG: [3, 'Sudeste', '30130-000'],
    PR: [3, 'Sul', '80060-000'],
    RS: [3, 'Sul', '90020-020'],
    SC: [3, 'Sul', '88015-200'],
    RJ: [4, 'Sudeste', '22010-000'],
    ES: [5, 'Sudeste', '29010-001'],
    BA: [6, 'Nordeste', '40020-468'],
    CE: [6, 'Nordeste', '60165-120'],
    PE: [6, 'Nordeste', '51020-000'],
    MS: [7, 'Centro-Oeste', '79002-075'],
    SE: [7, 'Nordeste', '49010-340'],
    AL: [8, 'Nordeste', '57080-128'],
    MT: [8, 'Centro-Oeste', '78005-370'],
    PA: [8, 'Norte', '66010-000'],
    TO: [8, 'Norte', '77006-014'],
    AM: [9, 'Norte', '69005-160'],
    PB: [9, 'Nordeste', '58013-475'],
    PI: [9, 'Nordeste', '64001-020'],
    RN: [9, 'Nordeste', '59014-165'],
    RO: [9, 'Norte', '76801-097'],
    MA: [10, 'Nordeste', '65020-590'],
    AC: [12, 'Norte', '69900-088'],
    AP: [12, 'Norte', '68900-073'],
    RR: [13, 'Norte', '69301-161']
  };

  /* Nome por extenso -> sigla. Algumas APIs devolvem "Sao Paulo" em vez de SP. */
  var NOMES = {
    'acre': 'AC', 'alagoas': 'AL', 'amapa': 'AP', 'amazonas': 'AM',
    'bahia': 'BA', 'ceara': 'CE', 'distrito federal': 'DF',
    'espirito santo': 'ES', 'goias': 'GO', 'maranhao': 'MA',
    'mato grosso': 'MT', 'mato grosso do sul': 'MS', 'minas gerais': 'MG',
    'para': 'PA', 'paraiba': 'PB', 'parana': 'PR', 'pernambuco': 'PE',
    'piaui': 'PI', 'rio de janeiro': 'RJ', 'rio grande do norte': 'RN',
    'rio grande do sul': 'RS', 'rondonia': 'RO', 'roraima': 'RR',
    'santa catarina': 'SC', 'sao paulo': 'SP', 'sergipe': 'SE',
    'tocantins': 'TO'
  };

  /* Uma fonte só, de propósito.
   *
   * Havia aqui um segundo endereço (get.geojs.io) como reserva. Saiu em
   * 21/10/2026, com o bloco já no ar: o ipwho.is estourou a cota gratuita
   * (HTTP 429, Retry-After de ~6h) e TODO visitante caía na reserva — que
   * responde pelo ASN da operadora, não pelo IP. O ASN 4230 é da Claro e
   * resolve em Macapá, então cliente da Claro em São Paulo via "Amapá" e a
   * PDP prometia 12 dias úteis em vez de 2.
   *
   * Reserva ruim é pior do que reserva nenhuma: sem UF o bloco mantém a
   * janela genérica do Liquid, que é imprecisa mas não mente. */
  var FONTES = ['https://ipwho.is/?fields=success,country_code,region,region_code'];

  /* v2 nas chaves: quem já tem "AP" envenenado no cache da versão anterior
     perderia o conserto por até 7 dias. Trocar o nome invalida todos. */
  var CHAVE = 'phprazo:v2:uf';
  var CHAVE_TS = 'phprazo:v2:ts';
  var CHAVE_FIXA = 'phprazo:v2:fixa';
  var CHAVE_FALHA = 'phprazo:v2:falha';
  var VALIDADE = 7 * 24 * 60 * 60 * 1000;
  /* Depois de uma falha, não insistir por 6h. Foi a insistência a cada
     pageview que ajudou a queimar a cota. */
  var ESPERA_FALHA = 6 * 60 * 60 * 1000;

  /* Mesmo formato do Liquid da seção ("17 de out."), para o texto não mudar de
     cara quando o JS assume o lugar do que veio do servidor. */
  var MESES = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.',
               'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'];
  var SEMANA = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

  /* ---------- storage (modo privado derruba tudo isso) ---------- */

  function ler(chave) {
    try {
      return window.localStorage.getItem(chave);
    } catch (e) {
      return null;
    }
  }

  function gravar(chave, valor) {
    try {
      window.localStorage.setItem(chave, valor);
    } catch (e) {
      /* modo privado / storage bloqueado: segue sem persistir */
    }
  }

  function apagar(chave) {
    try {
      window.localStorage.removeItem(chave);
    } catch (e) {
      /* idem */
    }
  }

  /* ---------- UF ---------- */

  function semAcento(texto) {
    return String(texto).normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function normalizarUF(bruto) {
    if (!bruto) return null;
    var valor = semAcento(bruto).trim().toLowerCase();
    /* ISO 3166-2 vem como "BR-SP" em algumas respostas */
    if (valor.indexOf('br-') === 0) valor = valor.slice(3);
    var sigla = valor.toUpperCase();
    if (TABELA[sigla]) return sigla;
    var porNome = NOMES[valor.replace(/\s+/g, ' ')];
    return porNome || null;
  }

  function ufDoCache() {
    var fixa = normalizarUF(ler(CHAVE_FIXA));
    if (fixa) return fixa;
    var uf = normalizarUF(ler(CHAVE));
    if (!uf) return null;
    var ts = parseInt(ler(CHAVE_TS), 10);
    if (!ts || (Date.now() - ts) > VALIDADE) return null;
    return uf;
  }

  function extrairUF(json) {
    if (!json || json.success === false) return null;
    var pais = String(json.country_code || json.country || json.pais || '').toUpperCase();
    if (pais && pais !== 'BR' && pais !== 'BRAZIL' && pais !== 'BRASIL') return null;
    return normalizarUF(json.uf || json.region_code || json.regiao || json.region || json.state || '');
  }

  function buscar(url) {
    var controle = window.AbortController ? new AbortController() : null;
    var corta = window.setTimeout(function () {
      if (controle) controle.abort();
    }, 3500);

    var opcoes = { cache: 'no-store', headers: { Accept: 'application/json' } };
    if (controle) opcoes.signal = controle.signal;

    return fetch(url, opcoes)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (json) {
        window.clearTimeout(corta);
        return extrairUF(json);
      });
  }

  var promessa = null;

  /* Resolve a UF uma única vez por pageview, não importa quantos blocos peçam. */
  function obter(endpoint) {
    if (promessa) return promessa;

    var doCache = ufDoCache();
    if (doCache) {
      promessa = Promise.resolve(doCache);
      return promessa;
    }

    /* Falhou há pouco (cota estourada, offline): não bate de novo. */
    var falhou = parseInt(ler(CHAVE_FALHA), 10);
    if (falhou && (Date.now() - falhou) < ESPERA_FALHA) {
      promessa = Promise.resolve(null);
      return promessa;
    }

    var fila = endpoint ? [endpoint].concat(FONTES) : FONTES.slice();

    promessa = fila.reduce(function (anterior, url) {
      return anterior.then(function (uf) {
        return uf ? uf : buscar(url);
      });
    }, Promise.resolve(null)).then(function (uf) {
      if (uf) {
        gravar(CHAVE, uf);
        gravar(CHAVE_TS, String(Date.now()));
        apagar(CHAVE_FALHA);
      } else {
        gravar(CHAVE_FALHA, String(Date.now()));
      }
      return uf;
    });

    return promessa;
  }

  /* ---------- feriados e dias úteis ---------- */

  function chaveData(d) {
    return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
  }

  /* Meeus/Butcher: domingo de Páscoa, de onde saem Carnaval e Corpus Christi. */
  function pascoa(ano) {
    var a = ano % 19;
    var b = Math.floor(ano / 100);
    var c = ano % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31);
    var dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(ano, mes - 1, dia);
  }

  function somarDias(data, dias) {
    var nova = new Date(data.getTime());
    nova.setDate(nova.getDate() + dias);
    return nova;
  }

  var cacheFeriados = {};

  function feriados(ano) {
    if (cacheFeriados[ano]) return cacheFeriados[ano];
    var p = pascoa(ano);
    cacheFeriados[ano] = [
      new Date(ano, 0, 1),   /* Confraternização */
      somarDias(p, -48),     /* Carnaval (segunda) */
      somarDias(p, -47),     /* Carnaval (terça) */
      somarDias(p, -2),      /* Sexta-feira Santa */
      new Date(ano, 3, 21),  /* Tiradentes */
      new Date(ano, 4, 1),   /* Dia do Trabalho */
      somarDias(p, 60),      /* Corpus Christi */
      new Date(ano, 8, 7),   /* Independência */
      new Date(ano, 9, 12),  /* Nossa Senhora Aparecida */
      new Date(ano, 10, 2),  /* Finados */
      new Date(ano, 10, 15), /* Proclamação da República */
      new Date(ano, 10, 20), /* Consciência Negra */
      new Date(ano, 11, 25)  /* Natal */
    ].map(chaveData);
    return cacheFeriados[ano];
  }

  function ehUtil(data) {
    var dia = data.getDay();
    if (dia === 0 || dia === 6) return false;
    return feriados(data.getFullYear()).indexOf(chaveData(data)) === -1;
  }

  /* A contagem nunca inclui hoje: o primeiro dia útil contado é o próximo. */
  function somarUteis(inicio, dias) {
    var d = new Date(inicio.getTime());
    var restantes = dias;
    var voltas = 0;
    while (restantes > 0 && voltas < 500) {
      d.setDate(d.getDate() + 1);
      voltas++;
      if (ehUtil(d)) restantes--;
    }
    return d;
  }

  /* "17 de out." */
  function formatar(data) {
    return data.getDate() + ' de ' + MESES[data.getMonth()];
  }

  /* "quinta, 22 de out." */
  function formatarComDia(data) {
    return SEMANA[data.getDay()] + ', ' + formatar(data);
  }

  /* ---------- cálculo ---------- */

  function calcular(uf, opcoes) {
    var sigla = normalizarUF(uf);
    if (!sigla) return null;

    var cfg = opcoes || {};
    var linha = TABELA[sigla];
    var dias = linha[0] + (parseInt(cfg.manuseio, 10) || 0);

    /* "Agora" no fuso de Brasília, não no relógio do visitante — o mesmo
       cuidado que o snippets/delivery-estimate.liquid já tomava. */
    var agora = new Date();
    var brt = new Date(agora.getTime() + agora.getTimezoneOffset() * 60000 - 3 * 3600000);

    var corte = parseInt(cfg.corte, 10) || 0;
    /* Pedido depois do horário de corte só entra na separação do dia seguinte. */
    if (corte > 0 && brt.getHours() >= corte) dias += 1;

    var inicio = new Date(brt.getFullYear(), brt.getMonth(), brt.getDate());
    var data = somarUteis(inicio, dias);

    var folga = parseInt(cfg.folga, 10) || 0;
    var dataFim = folga > 0 ? somarUteis(data, folga) : data;

    return {
      uf: sigla,
      regiao: linha[1],
      cep: linha[2],
      dias: dias,
      diasTabela: linha[0],
      diasFim: dias + folga,
      data: data,
      dataFim: dataFim,
      texto: formatar(data),
      textoFim: formatar(dataFim),
      textoComDia: formatarComDia(data)
    };
  }

  /* Fixar a UF na mão (ex.: link "não é sua região?"). Quem desenha escuta o
     evento e se redesenha. */
  function definirUF(uf) {
    var sigla = normalizarUF(uf);
    if (!sigla) return null;
    gravar(CHAVE_FIXA, sigla);
    promessa = Promise.resolve(sigla);
    document.dispatchEvent(new CustomEvent('ph:prazo-uf', { detail: { uf: sigla } }));
    return sigla;
  }

  function limpar() {
    apagar(CHAVE);
    apagar(CHAVE_TS);
    apagar(CHAVE_FIXA);
    apagar(CHAVE_FALHA);
    promessa = null;
  }

  window.PHPrazo = {
    tabela: TABELA,
    obter: obter,
    calcular: calcular,
    definirUF: definirUF,
    limpar: limpar
  };
}());
